import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const histogramDescription: CalculatorDescription = {
  id: CalculatorId.Histogram,
  title: 'Histogram Maker',
  metaTitle: 'Free Online Histogram Maker - Create Frequency Distributions',
  description: 'Create histograms to visualize data distribution and frequency. Perfect for analyzing continuous data, showing patterns, and identifying distribution shapes.',
  metaDescription: 'Make histograms online with our free tool. Visualize frequency distributions, analyze data patterns, and create professional statistical graphs.',
  howTo: {
    title: 'How to Create a Histogram',
    steps: [
      'Enter your data directly into the table or upload a CSV file',
      'Use the "Data column" control to select which numeric column to analyze',
      'Add a title to your histogram using the "Chart title" field',
      'Adjust the number of bins using the "Number of bins" control in the Appearance tab',
      'View your histogram to analyze the frequency distribution of your data'
    ],
    graphic: {
      description: 'An echarts histogram with adjustable bins, accompanied by a shadcn number input for bin configuration'
    }
  },
  examples: [
    {
      title: 'Height Distribution',
      description: 'Normal/Gaussian',
      dataDescription: 'Population height measurements',
      insights: [
        'Shows population height patterns',
        'Identifies central tendency',
        'Displays symmetry of distribution',
        'Highlights outliers'
      ]
    },
    {
      title: 'Response Times',
      description: 'Right-skewed',
      dataDescription: 'Service response time data',
      insights: [
        'Shows frequency of response times',
        'Identifies most common ranges',
        'Highlights performance patterns',
        'Detects unusual delays'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BarGraph,
    CalculatorId.ScatterChart,
    CalculatorId.XYPlot
  ]
}; 